import React from "react";

function hexToRgbA(hex) {
    var c;

    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split("");
        if (c.length == 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = "0x" + c.join("");
        return "rgba(" + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") + ",0.8)";
    }

    console.warn("Bad Hex");
}

export function ECommerceCarouselStyles(params = {}) {
    const { MobileBreakpoint, palette } = params;

    return {
        "& .carousel": {
            position: "relative",
            overflow: "hidden",
            scale: 0.9,

            "& .inner": {
                display: "flex",
                alignItems: "center",
                transition: "transform 0.5s ease-in-out",
                width: `calc(100% * var(--carousel-items))`,
                transform: `translateX(calc(-1 * var(--carousel-active-index) * (100% / var(--carousel-items))))`,
            },

            [MobileBreakpoint]: {},
        },

        // TEXT ON IMAGE
        "& .carousel-item": {
            display: "grid",
            gridTemplateColumns: "1fr auto",
            alignItems: "center",
            width: "100%",
            height: "100%",

            "& .carousel-item-grid": {
                display: "grid",
            },

            "& .carousel-item-text": {
                position: "fixed",
                top: "50%",
                maxWidth: "500px",
                alignSelf: "center",
                padding: "48px",
                margin: "0 48px",
                zIndex: 1,

                fontSize: "30px",
                fontWeight: "700",
                wordBreak: "break-word",

                background: palette.primary.initial,
                background: hexToRgbA(palette.primary.initial),
                color: palette.primary.initialText,

                [MobileBreakpoint]: {
                    alignSelf: "center",
                    width: "200px",
                    padding: "12px",
                    fontSize: "12px",
                },
            },

            "& .carousel-item-image": {
                width: "100%",
                height: "100%",
                objectFit: "contain",
                objectPosition: "center",
                // height: "40vh",
                // objectFit: "cover",
                maxHeight: "40vh",
            },
        },

        // INDICATORS
        "& .carousel-indicators": {
            display: "flex",
            justifyContent: "center",
            marginTop: "10px",
            gap: "6px",
            position: "absolute",
            bottom: "20px",
            left: "0",
            right: "0",
            zIndex: 2,

            "&.hide": {
                display: "none",
            },

            [MobileBreakpoint]: {
                display: "none",
            },
        },

        "& .indicator": {
            boxSizing: "border-box",
            width: "8px",
            height: "8px",

            borderRadius: "50%",

            backgroundColor: "#f1f1f1",
            border: "1px solid #999999",

            cursor: "pointer",
            transition: "background-color 0.3s",
        },

        "& .indicator.active": {
            backgroundColor: "#999999",
            border: "1px solid #f1f1f1",
        },

        "& .indicator:hover": {
            transform: "scale(1.2)",
        },

        // BUTTONS
        "& .buttons-container": {
            position: "absolute",
            top: "50%",
            left: "0",
            right: "0",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",

            height: "100%",
            width: "100%",

            transform: "translateY(-50%)",
            "& .prev-button, .next-button": {
                position: "absolute",
                top: "50%",
                display: "flex",
                width: "50px",
                height: "50px",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "rgba(204,204,204,0.5)",
                border: 0,

                opacity: 0,
                transition: "all 300ms ease",
                cursor: "pointer",
                transform: "translateY(-50%)",
            },

            "& .prev-button": {
                left: "0",
            },

            "& .next-button": {
                right: "0",
            },

            "&:hover": {
                "& .prev-button, .next-button": {
                    opacity: 1,
                },
            },

            "&.hide": {
                display: "none",
            },

            [MobileBreakpoint]: {
                display: "none",
            },
        },

        "& .buttons-container-button": {
            "&.prev-button, &.next-button": {
                position: "absolute",
                top: "50%",
                display: "flex",
                width: "50px",
                height: "50px",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "rgba(204, 204, 204, 0.5)",
                border: 0,

                opacity: 0,
                transition: "all 300ms ease",
                cursor: "pointer",
                transform: "translateY(-50%)",

                "&:hover": {
                    filter: "brightness(2)",
                    // backgroundColor: "rgba(204, 204, 204, 0.5)",
                },
            },

            "&.prev-button": {
                left: "0",
            },

            "&.next-button": {
                right: "0",
            },

            "&:hover": {
                "&.prev-button, &.next-button": {
                    opacity: 1,
                },
            },

            "&.hide": {
                display: "none",
            },
        },

        "& .carousel:hover .buttons-container-button": {
            opacity: 1,
        },

        // ROW IMAGES
        "& .carousel-small": {
            position: "relative",
            overflow: "hidden",
            padding: "10px",

            [MobileBreakpoint]: {
                display: "none",
            },
        },

        "& .carousel-small-inner": {
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: "20px",
            margin: "0 auto",
            // transition: "transform 0.5s ease-in-out",
            // transform: `translateX(calc(-${params.activeIndex} * 140px))`,

            "&.center": {
                justifyContent: "center",
            },
        },

        "& .carousel-small-image": {
            width: "130px",
            height: "130px",
            objectFit: "cover",
            boxSizing: "border-box",
            transition: "border 0.3s ease-in-out",
        },

        "& .carousel-small-image.active": {
            border: "1px solid #000000",
            boxSizing: "border-box",
            transiton: "border 0.3s ease-in-out",
        },

        "& .carousel-small-button": {
            border: "none",
            background: "none",
            cursor: "pointer",

            "&.youtube": {
                width: "130px",
                height: "130px",
                background: "transparent url('/img/youtube-icon.png') center / 80px no-repeat",
                filter: "drop-shadow(0 0 2px #ffffff)",

                "& img": {
                    opacity: 0,
                },
            },
        },

        "& .small-button-container": {
            position: "absolute",
            top: "50%",
            display: "flex",
            alignItems: "center",

            height: "100%",
            width: "70px",

            transform: "translateY(-50%)",
        },

        "& .small-button-container.prev": {
            left: "0",
        },
        "& .small-button-container.next": {
            right: "-20px",
        },

        "& .small-button": {
            position: "absolute",
            top: 0,
            bottom: 0,
            display: "flex",
            width: "48px",
            height: "100%",

            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(204,204,204,0.5)",
            border: 0,

            opacity: 0,
            transition: "all 300ms ease",
            cursor: "pointer",
        },

        "& .small-button:hover": {
            opacity: 1,
        },
    };
}

export default function ECommerceCarousel(props) {
    const { items } = props;

    if (!items) {
        return null;
    }

    const _items = items || [];
    if (!Array.isArray(_items)) {
        console.warn("ECommerce carousel items is not array!");
        return null;
    }

    const [activeIndex, setActiveIndex] = React.useState(0);
    const [paused, setPaused] = React.useState(false);
    const smallCarouselRef = React.useRef(null);
    const [smallCarouselPosition, setSmallCarouselPosition] = React.useState(0);

    const nextSlide = () => {
        setActiveIndex(prevIndex => (prevIndex + 1) % _items.length);
    };

    const prevSlide = () => {
        setActiveIndex(prevIndex => (prevIndex - 1 + _items.length) % _items.length);
    };

    const nextSmallCarousel = () => {
        const maxPosition = (_items.length - 4) * 150;
        setSmallCarouselPosition(prevPosition => Math.min(prevPosition + 150, maxPosition));
    };

    const prevSmallCarousel = () => {
        setSmallCarouselPosition(prevPosition => Math.max(prevPosition - 150, 0));
    };

    // Infinite Loop
    React.useEffect(() => {
        const interval = setInterval(() => {
            if (!paused) {
                nextSlide();
            }
        }, 3000);

        return () => {
            clearInterval(interval);
        };
    }, [paused]);

    React.useEffect(() => {
        if (smallCarouselRef.current) {
            const itemWidth = 150;
            const totalItems = smallCarouselRef.current.children.length;

            const maxIndex = totalItems - 4;
            const targetIndex = Math.min(activeIndex, maxIndex);

            const targetPosition = targetIndex * itemWidth;
            smallCarouselRef.current.style.transition = "transform 0.5s ease-in-out";
            smallCarouselRef.current.style.transform = `translateX(-${targetPosition}px)`;

            setSmallCarouselPosition(targetPosition);
        }
    }, [activeIndex]);

    // Swipe Handlers
    let touchStartX = 0;
    let touchStartY = 0;
    let touchCurrentX = 0;
    let touchCurrentY = 0;

    let isTouchMove = false;

    const handleTouchStart = event => {
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;

        isTouchMove = false;
    };

    const handleTouchMove = event => {
        touchCurrentX = event.touches[0].clientX;
        touchCurrentY = event.touches[0].clientY;

        const deltaX = Math.abs(touchStartX - touchCurrentX);
        const deltaY = Math.abs(touchStartY - touchCurrentY);

        if (deltaX > deltaY) {
            // Horizontal swipe, prevent vertical scroll
            isTouchMove = true;
            event.cancelable && event.preventDefault();
        }
    };

    const handleTouchEnd = () => {
        if (isTouchMove) {
            const swipeThreshold = 50; // Minimum swipe distance
            const deltaX = touchStartX - touchCurrentX;
            const deltaY = Math.abs(touchStartY - touchCurrentY);

            if (Math.abs(deltaX) > swipeThreshold && deltaY < Math.abs(deltaX)) {
                if (deltaX < 0) {
                    prevSlide();
                } else {
                    nextSlide();
                }
            }
        }

        // Reset touch states
        touchStartX = 0;
        touchStartY = 0;
        touchCurrentX = 0;
        touchCurrentY = 0;

        isTouchMove = false;
    };

    const CNCarousel = ["carousel carousel-big"];
    const CNSliderButtons = ["buttons-container"];
    const CNSliderIndicators = ["carousel-indicators"];
    const CNCarrouselSmallInner = ["carousel-small-inner"];

    const innerStyle = {
        "--carousel-items": _items.length,
        "--carousel-active-index": activeIndex,
    };

    _items.length < 2 && CNSliderButtons.push("hide");
    _items.length < 2 && CNSliderIndicators.push("hide");
    _items.length < 4 && CNCarrouselSmallInner.push("center");
    return (
        <div>
            <div
                className={CNCarousel}
                onMouseEnter={() => setPaused(true)}
                onMouseLeave={() => setPaused(false)}
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
            >
                <div className="inner" style={innerStyle}>
                    {_items?.map((item, index) => {
                        if (item?.type === "youtube" && item.id && item.link) {
                            // ! TODO, read todo of YoutubePlayer()
                            return (
                                // <div key={index} className="carousel-item">
                                //     <YoutubePlayer id={item.id} />
                                // </div>
                                <div
                                    key={index}
                                    className="carousel-item"
                                    dangerouslySetInnerHTML={{
                                        __html: `<iframe width="560" height="315" src="https://www.youtube.com/embed/${item.id}?controls=0&showinfo=0&rel=0&modestbranding=1&iv_load_policy=3&disablekb=1&autoplay=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`,
                                    }}
                                />
                            );
                        }

                        if (!item?.retina) {
                            return null;
                        }

                        return (
                            <div className="carousel-item" key={index}>
                                <div className="carousel-item-grid">
                                    <img className="carousel-item-image" src={item.retina} alt={`Slide ${index}`} />

                                    {item.text && (
                                        <div className="carousel-item-text">
                                            <p>{item.text}</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div className={CNSliderIndicators.join(" ")}>
                    {_items?.map((_, index) => (
                        <button
                            key={index}
                            className={`indicator ${index === activeIndex ? "active" : ""}`}
                            ignoreconversion=""
                            onClick={() => setActiveIndex(index)}
                        />
                    ))}
                </div>

                {/* <div className={CNSliderButtons.join(" ")}> */}
                <button className="buttons-container-button prev-button" ignoreconversion="" onClick={prevSlide}>
                    <img src="/img/left-arrow.svg" alt="&#8592;" />
                </button>

                <button className="buttons-container-button next-button" ignoreconversion="" onClick={nextSlide}>
                    <img src="/img/right-arrow.svg" alt="&#8594;" />
                </button>
                {/* </div> */}
            </div>

            <div className="carousel-small">
                <div
                    className={CNCarrouselSmallInner.join(" ")}
                    ref={smallCarouselRef}
                    style={{ transform: `translateX(-${smallCarouselPosition}px)` }}
                >
                    {_items?.map((item, index) => {
                        if (item?.type === "youtube" && item.id && item.link) {
                            return (
                                <button
                                    key={index}
                                    className="carousel-small-button youtube"
                                    onClick={() => setActiveIndex(index)}
                                >
                                    <img
                                        className={`carousel-small-image ${activeIndex === index ? "active" : ""}`}
                                        src="/img/youtube-icon.png"
                                        alt={`Youtube Slide`}
                                    />
                                </button>
                            );
                        }

                        if (!item?.normal) {
                            return null;
                        }

                        return (
                            <button key={index} className="carousel-small-button" onClick={() => setActiveIndex(index)}>
                                <img
                                    className={`carousel-small-image ${activeIndex === index ? "active" : ""}`}
                                    src={item.normal}
                                    alt={`Image ${index}`}
                                />
                            </button>
                        );
                    })}
                </div>

                {_items.length > 4 && (
                    <div className="small-button-container prev">
                        <button className="small-button small-prev" ignoreconversion="" onClick={prevSmallCarousel}>
                            <img src="/img/left-arrow.svg" alt="&#8592;" />
                        </button>
                    </div>
                )}

                {_items.length > 4 && (
                    <div className="small-button-container next">
                        <button className="small-button small-next" ignoreconversion="" onClick={nextSmallCarousel}>
                            <img src="/img/right-arrow.svg" alt="&#8594;" />
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}

// ! TODO - Need for stop auto slide change when video is playing
function YoutubePlayer(props) {
    console.warn("YoutubePlayer()", { props });

    const ScriptId = "YouTubeIframeApi";
    // const ElementId = `YTP-${Date.now()}`;

    const [ElementId, setElementId] = React.useState(`YTP-${Date.now()}`);

    console.log("YOUTUBE RENDER", ScriptId);

    React.useEffect(() => {
        // Players
        window.YTPlayers = window.YTPlayers || {};
        window.YTPlayers[ElementId] = { apply: false, player: null };

        window.onPlayerReady =
            window.onPlayerReady ||
            function onPlayerReady(event) {
                console.log(`YOUTUBE onPlayerReady()`, event);
            };

        window.onPlayerStateChange =
            window.onPlayerStateChange ||
            function onPlayerStateChange(event) {
                console.log(`YOUTUBE onPlayerStateChange()`, event);
            };

        // Workers
        window.onYouTubeIframeAPIReady =
            window.onYouTubeIframeAPIReady ||
            function onYouTubeIframeAPIReady() {
                for (const eid in window.YTPlayers[ElementId]) {
                    if (window.YTPlayers[ElementId].apply) {
                        continue;
                    }

                    const x = window.YTPlayers[ElementId];

                    x.apply = true;

                    x.player = new window.YT.Player(eid, {
                        width: "640",
                        height: "390",
                        videoId: props.id,
                        playerVars: { playsinline: 1 },
                        events: {
                            onReady: onPlayerReady,
                            onStateChange: onPlayerStateChange,
                        },
                    });

                    console.warn("YOUTUBE!!", x.player);
                }
            };

        // Add Script
        const YTIA = document.head.querySelector(`script#${ScriptId}`);

        if (!YTIA) {
            const domScript = document.createElement("script");
            domScript.setAttribute("id", ScriptId);
            domScript.setAttribute("src", "https://www.youtube.com/iframe_api");
            console.log("YOUTUBE IFRAME API LOADING...");
            document.head.appendChild(domScript);
        }
    }, []);

    return (
        <div id={ElementId} dangerouslySetInnerHTML={{ __html: `<iframe id="${ElementId}"></iframe>` }}>
            {/* <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/${item.id}?controls=0&showinfo=0&rel=0&modestbranding=1&iv_load_policy=3&disablekb=1&autoplay=0"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
            /> */}
        </div>
    );
}
